<div class="form_account page_service">

    <div class="infos_user">
        <div class="row h_full">
            @if(user.value) {
                <div class="col y_items_center">
                    <span class="name"><span>{{user.value.firstName.charAt(0) + user.value.lastName.charAt(0) }}</span>{{ user.value.firstName + ' ' + user.value.lastName }}</span>
                </div>
            }
        </div>
    </div>

    <ng-container>
        <mat-tab-group #tabGroup [(selectedIndex)]="selectedIndex" (selectedIndexChange)="selectedIndex">
            <mat-tab label="{{'services.form.service.value' | translate}}">
                <ng-container *ngTemplateOutlet="services"></ng-container>
            </mat-tab>
            @if(documentsManagementAllowed) {
                <mat-tab #documentTab>
                    <ng-template mat-tab-label>
                        <span>{{'services.form.file.value' | translate}}</span>
                        <img [src]="documentTab.isActive ? 'assets/images/mangopay-logo-white.svg' : 'assets/images/mangopay-logo.svg'" alt="" title=""/>
                    </ng-template>
                    <ng-container *ngTemplateOutlet="files"></ng-container>
                </mat-tab>
            }
        </mat-tab-group>
    </ng-container>
    <ng-template #services>

        <div class="title_tab">
            <div class="row marges h_full x_between">
                <div class="col_content y_items_center">
                    <span class="title">{{'services.form.service.value' | translate}}</span>
                </div>
            </div>
        </div>

        <div class="content_tab">
            @if(user.value) {
                <app-service-list [user]="user.value"></app-service-list>
            }
        </div>

    </ng-template>
    <ng-template #files>

        <div class="title_tab">
            <div class="row marges h_full x_between">
                <div class="col_content y_items_center">
                    <span class="title">{{'services.form.file.value' | translate}}</span>
                </div>
            </div>
        </div>

        <div class="content_tab content_cards">
            <p [innerHTML]="'services.form.file.infos.value' | translate | safeHtml"></p>

            <div class="content_forms">

                <!-- Représentant légal -->

                <div class="content_form">
                    <div class="header_form">
                        <span class="title">{{ 'society.legalRepresentative.value' | translate }}</span>
                    </div>
                    <div class="body_form">
                        <ng-container [formGroup]="form">

                            <ng-container formGroupName="society">

                                <div formGroupName="legalRepresentative">
                                    <div class="row marges ligne_form">
                                        <div class="col_12">

                                            <!-- Civilité -->

                                            <div class="form-group">
                                                <label>{{'form.user.fields.civility.title.value' | translate}}</label>
                                                <div class="radio">
                                                    <input type="radio" [value]="1" formControlName="civility" class="form-control" id="legalRepresentative-civility-mister">
                                                    <label for="legalRepresentative-civility-mister">{{'form.user.fields.civility.mister.value' | translate}}</label>
                                                </div>
                                                <div class="radio">
                                                    <input type="radio" [value]="2" formControlName="civility" class="form-control" id="legalRepresentative-civility-madam">
                                                    <label for="legalRepresentative-civility-madam">{{'form.user.fields.civility.madam.value' | translate}}</label>
                                                </div>
                                                @if(societyLegalRepresentativeControl.get('civility').errors && (societyLegalRepresentativeControl.get('civility').dirty || societyLegalRepresentativeControl.get('civility').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(societyLegalRepresentativeControl.get('civility').errors.required) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row marges ligne_form">
                                        <div class="col_12 col_md_4">

                                            <!-- Nom -->

                                            <div class="form-group">
                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="lastName" id="legalRepresentativeLastName" required="required">
                                                <label for="legalRepresentativeLastName">{{'form.user.fields.lastname.value' | translate}}</label>
                                                @if(societyLegalRepresentativeControl.get('lastName').errors && (societyLegalRepresentativeControl.get('lastName').dirty || societyLegalRepresentativeControl.get('lastName').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(societyLegalRepresentativeControl.get('lastName').errors.required) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>
                                        </div>
                                        <div class="col_12 col_md_4">

                                            <!-- Prénom -->

                                            <div class="form-group">
                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="firstName" id="legalRepresentativeFirstName" required="required">
                                                <label for="legalRepresentativeFirstName">{{'form.user.fields.firstname.value' | translate}}</label>
                                                @if(societyLegalRepresentativeControl.get('firstName').errors && (societyLegalRepresentativeControl.get('firstName').dirty || societyLegalRepresentativeControl.get('firstName').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(societyLegalRepresentativeControl.get('firstName').errors.required) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>
                                        </div>

                                        <div class="col_12 col_md_4">

                                            <!-- Téléphone -->

                                            <div class="form-group">

                                                <app-core-intl-tel-input [formGroup]="societyLegalRepresentativeControl" [controlName]="'phone'" customPlaceholder="{{'form.user.fields.legalRepresentative.phone.value' | translate}}"></app-core-intl-tel-input>

                                                @if(societyLegalRepresentativeControl.get('phone').errors && (societyLegalRepresentativeControl.get('phone').dirty || societyLegalRepresentativeControl.get('phone').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(societyLegalRepresentativeControl.get('phone').errors.required) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                            @if(societyLegalRepresentativeControl.get('phone').errors.validatePhoneNumber) {
                                                                <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row marges ligne_form">

                                        <div class="col_12 col_md_4">

                                            <!-- Nationalité -->

                                            <div class="form-group">
                                                <select class="form-control" id="legalRepresentativeNationality" formControlName="nationality" required="required">
                                                    <option *ngFor="let country of countries$ | async" [value]="country.code">
                                                        {{ translationService.getFallbackTranslation(country.translations).name }}
                                                    </option>
                                                </select>
                                                <label class="required" for="legalRepresentativeNationality">{{ 'form.user.fields.nationality.value' | translate }}</label>
                                                @if(societyLegalRepresentativeControl.get('nationality').invalid && (societyLegalRepresentativeControl.get('nationality').dirty || societyLegalRepresentativeControl.get('nationality').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(societyLegalRepresentativeControl.get('nationality').errors.required) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>
                                        </div>

                                        <div class="col_12 col_md_4">

                                            <!-- Date de naissance -->

                                            <div class="form-group">
                                                <app-input-date [form]="societyLegalRepresentativeControl" [config]="birthDayConfig"></app-input-date>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="row marges ligne_form">
                                        <div class="col_12 col_md_6">

                                            <!-- Adresse -->

                                            <div class="form-group">
                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="address" id="legalRepresentativeAddress" required="required">
                                                <label for="legalRepresentativeAddress">{{'form.user.fields.address.value' | translate}}</label>
                                                @if(societyLegalRepresentativeControl.get('address').errors && (societyLegalRepresentativeControl.get('address').dirty || societyLegalRepresentativeControl.get('address').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(societyLegalRepresentativeControl.get('address').errors.required) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>
                                        </div>

                                        <div class="col_12 col_md_6">

                                            <!-- Complément d'adresse -->

                                            <div class="form-group">
                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="additionalAddress" id="legalRepresentativeAdditionalAddress">
                                                <label for="legalRepresentativeAdditionalAddress">{{'form.user.fields.additionalAddress.value' | translate}}</label>
                                                @if(societyLegalRepresentativeControl.get('additionalAddress').errors && (societyLegalRepresentativeControl.get('additionalAddress').dirty || societyLegalRepresentativeControl.get('additionalAddress').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(societyLegalRepresentativeControl.get('additionalAddress').errors.required) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row marges ligne_form">
                                        <div class="col_12 col_md_6">

                                            <!-- Code postal -->

                                            <div class="form-group">
                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="zipcode" id="legalRepresentativeZipcode" required="required">
                                                <label for="legalRepresentativeZipcode">{{'form.user.fields.zipcode.value' | translate}}</label>
                                                @if(societyLegalRepresentativeControl.get('zipcode').errors && (societyLegalRepresentativeControl.get('zipcode').dirty || societyLegalRepresentativeControl.get('zipcode').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(societyLegalRepresentativeControl.get('zipcode').errors.required) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                            @if(societyLegalRepresentativeControl.get('zipcode').errors.pattern) {
                                                                <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>
                                        </div>
                                        <div class="col_12 col_md_6">

                                            <!-- Ville -->

                                            <div class="form-group">
                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="city" id="legalRepresentativeCity" required="required">
                                                <label for="legalRepresentativeCity">{{'form.user.fields.city.value' | translate}}</label>
                                                @if(societyLegalRepresentativeControl.get('city').errors && (societyLegalRepresentativeControl.get('city').dirty || societyLegalRepresentativeControl.get('city').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(societyLegalRepresentativeControl.get('city').errors.required) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row marges ligne_form">
                                        <div class="col_12 col_md_6">

                                            <!-- Région -->

                                            <div class="form-group">
                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="region" id="legalRepresentativeRegion">
                                                <label for="legalRepresentativeRegion">{{'form.user.fields.region.value' | translate}}</label>
                                                @if(societyLegalRepresentativeControl.get('region').errors && (societyLegalRepresentativeControl.get('region').dirty || societyLegalRepresentativeControl.get('region').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(societyLegalRepresentativeControl.get('region').errors.isRequired) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>
                                        </div>

                                        <div class="col_12 col_md_6">

                                            <!-- Pays -->

                                            <div class="form-group">
                                                <select class="form-control" id="legalRepresentativeCountry" formControlName="country" required="required">
                                                    <option *ngFor="let country of countries$ | async" [value]="country.code">
                                                        {{ translationService.getFallbackTranslation(country.translations).name }}
                                                    </option>
                                                </select>
                                                <label class="required" for="legalRepresentativeCountry">{{ 'form.user.fields.country.value' | translate }}</label>
                                                @if(societyLegalRepresentativeControl.get('country').invalid && (societyLegalRepresentativeControl.get('country').dirty || societyLegalRepresentativeControl.get('country').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(societyLegalRepresentativeControl.get('country').errors.required) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br/>
                                <p>{{ 'services.form.file.infos.society.value' | translate}} </p>

                            </ng-container>

                        </ng-container>
                    </div>
                </div>

                <!-- Recipient -->

                @if(isRequiredDocument('recipient')) {
                    <div class="content_form">
                        <div class="header_form">
                            <span class="title">{{ 'services.form.file.bank_account.value' | translate }}</span>
                        </div>
                        <div class="body_form">

                            <form [formGroup]="form" (ngSubmit)="accountSubmit()" class="form_service_file">

                                <ng-container formGroupName="society">

                                    <div formGroupName="recipient">

                                        <div class="form-group">
                                        <span class="message-help">
                                            <mat-icon class="tooltip_icon">info</mat-icon>
                                            {{ 'services.form.recipient.help.value' | translate }}
                                        </span>
                                        </div>

                                        @if (recipient?.status){

                                            <div class="form-group">
                                                <p [ngClass]="recipient.status" class="status">
                                                    {{ 'recipient.form.latest.status.value' | translate }} : <span>{{ recipientStatusLabel | translate }}</span>
                                                </p>
                                                <br>
                                            </div>
                                        }

                                        <div class="row marges ligne_form">
                                            <div class="col_12">
                                                <div class="form-group">
                                                    <input type="text" value="" placeholder=" " class="form-control" formControlName="ownerName" id="ownerName">
                                                    <label class="required" for="ownerName">{{'services.form.file.bank_account.ownerName.value' | translate}}</label>
                                                    @if(recipientControl.get('ownerName').errors && (recipientControl.get('ownerName').dirty || recipientControl.get('ownerName').touched)) {
                                                        <mat-error>
                                                            <div class="invalid-feedback">
                                                                @if(recipientControl.get('ownerName').errors.required) {
                                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                }
                                                            </div>
                                                        </mat-error>
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row marges ligne_form">
                                            <div class="col_12 y_items_center">
                                                <app-core-google-places-location [fields]="getAddressLocationFields(recipientAddressControl)"></app-core-google-places-location>
                                            </div>
                                        </div>

                                        <div formGroupName="address" class="row marges ligne_form">

                                            <div class="col_12">

                                                <div class="row marges ligne_form">

                                                    <div class="col_12 col_md_6">

                                                        <!-- Adresse -->

                                                        <div class="form-group">
                                                            <input type="text" value="" placeholder=" " class="form-control" formControlName="address" id="recipientAddress" required="required">
                                                            <label for="recipientAddress">{{'form.user.fields.address.value' | translate}}</label>
                                                            @if(recipientAddressControl.get('address').errors && (recipientAddressControl.get('address').dirty || recipientAddressControl.get('address').touched)) {
                                                                <mat-error>
                                                                    <div class="invalid-feedback">
                                                                        @if(recipientAddressControl.get('address').errors.required) {
                                                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                        }
                                                                    </div>
                                                                </mat-error>
                                                            }
                                                        </div>
                                                    </div>

                                                    <div class="col_12 col_md_6">

                                                        <!-- Complément d'adresse -->

                                                        <div class="form-group">
                                                            <input type="text" value="" placeholder=" " class="form-control" formControlName="additionalAddress" id="recipientAdditionalAddress">
                                                            <label for="recipientAdditionalAddress">{{'form.user.fields.additionalAddress.value' | translate}}</label>
                                                            @if(recipientAddressControl.get('additionalAddress').errors && (recipientAddressControl.get('additionalAddress').dirty || recipientAddressControl.get('additionalAddress').touched)) {
                                                                <mat-error>
                                                                    <div class="invalid-feedback">
                                                                        @if(recipientAddressControl.get('additionalAddress').errors.required) {
                                                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                        }
                                                                    </div>
                                                                </mat-error>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row marges ligne_form">
                                                    <div class="col_12 col_md_6">

                                                        <!-- Code postal -->

                                                        <div class="form-group">
                                                            <input type="text" value="" placeholder=" " class="form-control" formControlName="zipcode" id="recipientZipcode" required="required">
                                                            <label for="recipientZipcode">{{'form.user.fields.zipcode.value' | translate}}</label>
                                                            @if(recipientAddressControl.get('zipcode').errors && (recipientAddressControl.get('zipcode').dirty || recipientAddressControl.get('zipcode').touched)) {
                                                                <mat-error>
                                                                    <div class="invalid-feedback">
                                                                        @if(recipientAddressControl.get('zipcode').errors.required) {
                                                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                        }
                                                                        @if(recipientAddressControl.get('zipcode').errors.pattern) {
                                                                            <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                                                        }
                                                                    </div>
                                                                </mat-error>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div class="col_12 col_md_6">

                                                        <!-- Ville -->

                                                        <div class="form-group">
                                                            <input type="text" value="" placeholder=" " class="form-control" formControlName="city" id="recipientCity" required="required">
                                                            <label for="recipientCity">{{'form.user.fields.city.value' | translate}}</label>
                                                            @if(recipientAddressControl.get('city').errors && (recipientAddressControl.get('city').dirty || recipientAddressControl.get('city').touched)) {
                                                                <mat-error>
                                                                    <div class="invalid-feedback">
                                                                        @if(recipientAddressControl.get('city').errors.required) {
                                                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                        }
                                                                    </div>
                                                                </mat-error>
                                                            }
                                                        </div>
                                                    </div>

                                                </div>

                                                <div class="row marges ligne_form">
                                                    <div class="col_12 col_md_6">

                                                        <!-- Région -->

                                                        <div class="form-group">
                                                            <input type="text" value="" placeholder=" " class="form-control" formControlName="region" id="recipientRegion">
                                                            <label  class="required" for="recipientRegion">{{'form.user.fields.region.value' | translate}}</label>
                                                            @if(recipientAddressControl.get('region').errors && (recipientAddressControl.get('region').dirty || recipientAddressControl.get('region').touched)) {
                                                                <mat-error>
                                                                    <div class="invalid-feedback">
                                                                        @if(recipientAddressControl.get('region').errors.required) {
                                                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                        }
                                                                    </div>
                                                                </mat-error>
                                                            }
                                                        </div>
                                                    </div>

                                                    <div class="col_12 col_md_6">

                                                        <!-- Pays -->

                                                        <div class="form-group">
                                                            <select class="form-control" id="recipientCountry" formControlName="country" required="required">
                                                                <option *ngFor="let country of countries$ | async" [value]="country.code">
                                                                    {{ translationService.getFallbackTranslation(country.translations).name }}
                                                                </option>
                                                            </select>
                                                            <label class="required" for="recipientCountry">{{ 'form.user.fields.country.value' | translate }}</label>
                                                            @if(recipientAddressControl.get('country').invalid && (recipientAddressControl.get('country').dirty || recipientAddressControl.get('country').touched)) {
                                                                <mat-error>
                                                                    <div class="invalid-feedback">
                                                                        @if(recipientAddressControl.get('country').errors.required) {
                                                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                        }
                                                                    </div>
                                                                </mat-error>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div formGroupName="bankTransfer" class="row marges ligne_form">

                                            <div class="col_12">

                                                <div class="ligne_form">
                                                    <div class="row marges ligne_form">
                                                        <div class="col_12 col_md_4">
                                                            <div class="form-group">
                                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="iban" id="iban">
                                                                <label class="required" for="iban">{{'services.form.file.bank_account.type.values.IBAN.value' | translate}}</label>
                                                                @if(recipientBankTransferControl.get('iban').errors && (recipientBankTransferControl.get('iban').dirty || recipientBankTransferControl.get('iban').touched)) {
                                                                    <mat-error>
                                                                        <div class="invalid-feedback">
                                                                            @if(recipientBankTransferControl.get('iban').errors.isRequired) {
                                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                            }
                                                                        </div>
                                                                    </mat-error>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div class="col_12 col_md_4">
                                                            <div class="form-group">
                                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="bic" id="bic">
                                                                <label class="required" for="bic">{{'services.form.file.bank_account.type.values.BIC.value' | translate}}</label>
                                                                @if(recipientBankTransferControl.get('bic').errors && (recipientBankTransferControl.get('bic').dirty || recipientBankTransferControl.get('bic').touched)) {
                                                                    <mat-error>
                                                                        <div class="invalid-feedback">
                                                                            @if(recipientBankTransferControl.get('bic').errors.isRequired) {
                                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                            }
                                                                        </div>
                                                                    </mat-error>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div class="col_12 col_md_4">
                                                            <div class="form-group">
                                                                <select class="form-control" id="bankTransferCurrency" formControlName="currency" [compareWith]="compareCurrency">
                                                                    <option [ngValue]="null"></option>
                                                                    <option *ngFor="let currency of currencies" [value]="currency">
                                                                        {{ translationService.getFallbackTranslation(currency.translations).label }} ({{ currency.code }})
                                                                    </option>
                                                                </select>
                                                                <label class="required" for="bankTransferCurrency">{{ 'currency.value' | translate }}</label>
                                                                @if(recipientBankTransferControl.get('currency').errors && (recipientBankTransferControl.get('currency').dirty || recipientBankTransferControl.get('currency').touched)) {
                                                                    <mat-error>
                                                                        <div class="invalid-feedback">
                                                                            @if(recipientBankTransferControl.get('currency').errors.required) {
                                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                            }
                                                                        </div>
                                                                    </mat-error>
                                                                }
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>

                                </ng-container>

                                <div class="row marges mt_24">

                                    <div class="col_12 x_end">

                                        <button class="btn_cta btn_little" type="submit">
                                            {{ 'services.form.submit'|translate }}
                                        </button>

                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                }

                <!-- Identity Verification -->

                @if(isRequiredDocument('identity-verification') && identityVerification) {

                    <div class="content_form">

                        <div class="header_form">
                            <span class="title">{{ 'services.form.identityVerification.value' | translate }}</span>
                        </div>

                        <div class="body_form">

                            <div class="row marges ligne_form">
                                <div class="col_12">
                                    <div class="form-group">
                                        <p [ngClass]="identityVerification.status" class="status">
                                            <strong>{{ 'services.form.identityVerification.status.value' | translate }} : </strong>
                                            <span>{{  'services.form.identityVerification.status.' + identityVerification.status + '.value' | translate }}</span>
                                        </p>
                                    </div>
                                </div>

                                <div class="col_12">
                                    <div class="form-group">
                                        <div class="ck-content">
                                            <ul>
                                                @for(document of identityVerification.documents; track document) {
                                                    <li>
                                                        <p [ngClass]="document.status" class="status">{{ 'services.form.identityVerification.document.' + document.type + '.value' | translate }}
                                                            : <span>{{  'services.form.identityVerification.document.status.' + document.status + '.value' | translate }}</span>
                                                            @if(document.status && isRefused(document.status) && document.errors) {
                                                                <span>
                                                                    @let errors = (document.errors | keyvalue);

                                                                    @for (error of errors; track error.key) {
                                                                        <br/>
                                                                        {{ 'services.form.identityVerification.document.refusalReason.' + error.key + '.value' | translate }}
                                                                        @if(error.value) {
                                                                            ({{ error.value }})
                                                                        }
                                                                    }
                                                                </span>
                                                            }
                                                        </p>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row marges ligne_form">
                                <div class="col_12">
                                    <div class="col_content">
                                        <button type="button" class="btn_cta btn_small" (click)="openIdentityVerificationDialog()">
                                            <span>{{ 'services.form.identityVerification.tunnel.create.value' | translate }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

            </div>
        </div>
    </ng-template>
</div>
